<!-- /src/views/Resources.vue -->
<template>
  <LayoutFullWidth>
    <template v-slot:header>
      <h1 class="page-header">Downloadable Resources</h1>
      <!-- <Filters headline="Resources" postType="resources" /> -->
    </template>
    <template v-slot:content>
      <div class="resources--header">
        <div
          v-if="activeQueries.length > 0" 
          class="current-filter--settings button__group">
          Filter Results: 
          <button
            v-for="(query, key) in activeQueries"
            :key="key"
            class="button button--withIcon button--tiny button--accent"
            @click="removeFilterItem(query.originalQuery)"
          >
          <span class="fas fa-times-circle"></span> {{ query.type }}: {{ query.name }}
          </button>
        </div>
        <div class="section__actions button__group">
          <button
            class="filter--trigger button button--gray button--tiny"
            @click="toggleFilters()"
          ><span v-if="activeQueries.length > 0">Modify Filtered Results</span>
          <span v-else>Filter Results</span></button>
        </div>
      </div>

      <div v-show="showFilters">
        <button
            class="button button--gray button--medium button--accent"
            @click="toggleFilters()"
          >Close Filter Panel</button>
        <Filters postType="resources" />
      </div>

      <div v-if="pageResources.length > 0" class="main-content">
        <Downloadable
          v-for="(file, index) in pageResources"
          :key="`resources_ind_${index}`"
          :file="file"
        />
        <Pagination :page="page" :total="totalPages" />
      </div>
      <Loader v-else-if="!(pageResources.length > 0)" color="gray" />
      <div v-else class="main-content">
        <h1>Whoops</h1>
        <h2>
          No results match the applied filters.
          <router-link :to="resetPage">Reset Filter</router-link>
        </h2>
      </div>
    </template>
  </LayoutFullWidth>
</template>

<script>
import { mapGetters } from 'vuex'
import LayoutFullWidth from '@/components/layouts/FullWidth'
import Filters from '@/components/common/Sidebar/Filters'
import Pagination from '@/components/common/Pagination'
import Downloadable from '@/components/common/Downloadable'
import Loader from '@/components/common/Loaders/Loader'
import { deepSearch } from '@/components/common/utils/helpers.js'
import searchMixin from '@/mixins/searchMixin'
import _omit from 'lodash/omit'
import _values from 'lodash/values'
import _each from 'lodash/each'
import _isNaN from 'lodash/isNaN'
import _pick from 'lodash/pick'
import _keys from 'lodash/keys'

export default {
  name: 'dashboard',
  data() {
    return {
      itemsPerPage: 10,
      showFilters: false,
    }
  },
  computed: {
    page() {
      const { page } = Object.create(this.$route.query)
      return typeof page != 'undefined' ? page : 1
    },
    sessions() {
      // console.log(this.$store.getters['posts/getAll']('sessions'))
      return this.$store.getters['posts/getAll']('sessions')
    },
    totalPages() {
      return this.resources.length / this.itemsPerPage
    },
    pageResources() {
      return this.resources.slice(
        (this.page - 1) * this.itemsPerPage,
        (this.page - 1) * this.itemsPerPage + this.itemsPerPage,
      )
    },

    resetPage() {
      const name = this.$route.name
      return {
        name,
      }
    },

    resources() {
      let output = []
      const { sessions } = this

      this.sessions.map(t => {
        let downloadableFiles = deepSearch(t, ['acf', 'downloadable_files'])
        if (downloadableFiles && Array.isArray(downloadableFiles)) {
          let file = {}
          downloadableFiles.forEach(file => {
            file = file.file
            if (file && typeof file == 'object') {
              file['session_type'] = t['session_type']
              file['origin'] = t['origin']
              file['tools'] = t['tools']
              file['deal_type'] = t['deal_type']
              file['verticals'] = t['verticals']
              file['deal-phases'] = t['deal-phases']
              file['authors'] = t['authors']
              file['type'] = t['type']
              output.push(file)
            }
          })
        }
      })
      // the order of these functions is important since sorting needs to happen after input search
      // output = this.searchViaInput(output)
      output = this.filterCards(output)
      return output
    },

    activeQueries() {
      const { $route, initialCaps } = this
      let { query } = $route
      query = _omit(query, ['page', 'sort'])
      let queryValues = []

      _each(query, (value, key) => {
        const numberValue = parseInt(value)
        const originalQuery = _pick(query, key)
        let queryItem = {}
        if (!_isNaN(numberValue)) {
          queryItem = this.$store.getters['taxies/filterItemsByProp'](key, numberValue)
          _each(queryItem, item => {
            queryValues.push({
              name: item.name,
              type: initialCaps(item.taxonomy),
              originalQuery
            })
          })
        } else {
          const name = initialCaps(value)
          const type = initialCaps(key.replace('session_', '').replace('_', ' '))
          // originalQuery[key] = value
          queryValues.unshift({
            name,
            type,
            originalQuery, 
          })
        }
      })
      return queryValues
    },
  },

  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters
    },

    initialCaps(string) {
      return string.split(' ').map(word => {
        return word[0].toUpperCase() + word.substr(1)
      }).join(' ')
    },

    removeFilterItem(queryItem) {
      let { query, name } = this.$route
      query = _omit(query, _keys(queryItem))
      this.$router.push({
        name,
        query,
      })
    },
  },

  mounted() {
    this.$store.dispatch('updatePageTitle', 'Resources')
  },

  mixins: [searchMixin],

  components: {
    LayoutFullWidth,
    Pagination,
    Filters,
    Downloadable,
    Loader,
  },
}
</script>

<style scoped>
.downloadable__itemWrap {
  margin-bottom: 2rem;
}

.resources {
  &--header {
    display: grid;
    grid-template-columns: 1fr auto;
    margin-bottom: 1rem;
  }
}

.section {
  &__actions {
    justify-self: end;
  }
}

.downloadable {
  margin-bottom: 1rem;
}

.pagination {
  margin-top: 1rem;
}
</style>
